/** Knowledge map pages i18n (en) — merged into knowledgeMap namespace */
export default {
  knowledgeMap: {
    main: {
      title: 'Knowledge map',
      myMaps: 'My knowledge maps',
      expandSidebar: 'Expand sidebar',
      collapseSidebar: 'Collapse sidebar',
      statTopics: 'Topics',
      statNodes: 'Knowledge points',
      statPinned: 'Pinned',
      searchTopics: 'Search topics...',
      newTopic: 'New topic',
      batchMode: 'Batch actions',
      mergeTopics: 'Merge topics',
      exportSelected: 'Export selected',
      batchSmartHeal: 'Batch smart heal',
      batchSmartHealAll: 'Smart heal all topics',
      deleteSelected: 'Delete selected',
      sortRecent: 'By last updated',
      sortNodeCount: 'By knowledge points',
      sortName: 'By name',
      noTopics: 'No topics yet',
      noMatchingTopics: 'No matching topics or loaded content',
      topicsLoadFailed: 'Failed to load topics',
      retry: 'Retry',
      dataSubscriptionDenied: 'Data subscription is not available on your plan',
      dataSubscriptionFeedDenied: 'Subscription feed is not available on your plan',
      unpin: 'Unpin',
      pin: 'Pin',
      rename: 'Rename',
      subscribeUpdates: 'Subscribe',
      subscribeConfig: 'Subscription settings',
      delete: 'Delete',
      emptyMain: 'No content yet. Save valuable findings from research to the knowledge map to build your personal map.',
      createFirstTopic: 'Create first topic',
      pinnedTag: 'Pinned',
      materialsCount: '{count} materials',
      categoriesCount: '{count} categories',
      updatedAgo: 'Updated {time}',
      viewUpdates: 'View updates',
      viewMindmap: 'Mind map',
      viewOutline: 'Outline',
      viewGraph: 'Knowledge graph',
      wikiMaintained: 'AI maintained',
      wikiOverview: 'Topic Wiki overview',
      wikiDesc: 'Scattered materials are organized into a traceable, reusable topic overview.',
      wikiStatus: 'Wiki status',
      lifecycle: 'Lifecycle',
      materialCount: 'Materials',
      wikiUpdated: 'Wiki updated',
      version: 'Version',
      wikiGenerating: 'Wiki is being generated in the background. This page will refresh automatically.',
      wikiGeneratingTip: 'Usually takes under a minute. Keep this page open.',
      wikiFailed: 'Last Wiki run failed; fallback Wiki kept: {error}',
      sourceBreakdown: 'Source breakdown',
      noSourceStats: 'No material sources to summarize',
      recentMaterials: 'Recent materials',
      noRecentMaterials: 'No recent materials',
      subscriptionPreview: 'Subscription preview',
      toc: 'Table of contents',
      copy: 'Copy',
      exportPackage: 'Topic package',
      regenerating: 'Generating',
      regenerate: 'Regenerate',
      smartHeal: 'Smart heal',
      healthCheck: 'Health check',
      archiveWiki: 'Archive Wiki',
      restoreWiki: 'Restore Wiki',
      semanticDiscuss: 'Semantic discussion',
      editSection: 'Edit section',
      searchNodes: 'Search knowledge points...',
      expandAll: 'Expand all',
      collapseAll: 'Collapse all',
      copyAll: 'Copy all',
      noMatchingNodes: 'No matching knowledge points',
      noNodes: 'No knowledge points in this topic',
      addNode: 'Add knowledge point',
      editMdPlaceholder: 'Enter Markdown...',
      dblClickEdit: 'Double-click to edit',
      edit: 'Edit',
      copyContent: 'Copy content',
      searchGraphNodes: 'Search nodes (Enter to locate)',
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      fitScreen: 'Fit screen',
      exportPng: 'Export PNG',
      exitFullscreen: 'Exit fullscreen',
      fullscreen: 'Fullscreen',
      searchNodesShort: 'Search nodes…',
      toggleLabels: 'Show/hide labels',
      lightTheme: 'Light theme',
      cosmicTheme: 'Cosmic theme',
      disableFocus: 'Disable neighborhood focus',
      enableFocus: 'Enable neighborhood focus',
      fitCanvas: 'Fit canvas',
      fullscreenExplore: 'Fullscreen explore',
      copyName: 'Copy name',
      archived: 'Indexed',
      notArchived: 'Not indexed',
      chars: '{count} chars',
      editSectionTitle: 'Edit section: {title}',
      editIntroSection: 'Edit introduction',
      sectionTitle: 'Section title',
      sectionTitlePlaceholder: 'Enter section title',
      sectionContent: 'Section content (Markdown)',
      sectionContentPlaceholder: 'Enter section content...',
      newTopicDialog: 'New topic',
      topicName: 'Topic name',
      topicNamePlaceholder: 'Enter topic name',
      newCategory: 'New category',
      categoryName: 'Category name',
      categoryNamePlaceholder: 'e.g. Mechanism / Clinical progress',
      addKnowledgeNode: 'Add knowledge point',
      targetCategory: 'Target category',
      uncategorized: 'Leave empty for uncategorized',
      nodeContent: 'Content (Markdown)',
      nodeContentPlaceholder: '**Key concept**: enter highlights here...',
      livePreview: 'Live preview',
      batchMoveNodes: 'Move knowledge points (batch)',
      moveNode: 'Move knowledge point',
      targetTopic: 'Target topic',
      moveCategory: 'Move category',
      wikiDiscuss: '💬 Topic Wiki semantic discussion',
      unnamedMaterial: 'Untitled material',
      noSnippet: 'No snippet',
      wikiAskPlaceholder: 'Ask Wiki... e.g. clinical links and safety limits for this target?',
      healthDiagnosis: '🔍 Knowledge graph health check',
      materialDetail: 'Material details',
      sortRecentLabel: 'Last updated',
      sortNodeCountLabel: 'Knowledge points',
      sortNameLabel: 'Name',
      sortLabel: 'Sort',
      noSummary: 'No summary',
      locatedInOutline: 'Located in outline',
      lifecycleDraft: 'Draft',
      lifecycleActive: 'Active',
      lifecycleStale: 'Stale',
      lifecycleContradicted: 'Contradicted',
      lifecycleArchived: 'Archived',
      wikiStatusGenerating: 'Generating',
      wikiStatusReady: 'Ready',
      wikiStatusFallback: 'Fallback',
      wikiStatusPending: 'Pending',
      sourceTargetAnalysis: 'Target analysis',
      sourceTargetChat: 'Report Q&A',
      sourceTargetReport: 'Target report',
      sourceReport: 'Target report',
      sourceChat: 'Chat',
      sourceEncyclopedia: 'Encyclopedia',
      depthAll: 'Expand all',
      depthLayers: '{n} levels',
      nodeTypeSynthesis: 'Synthesized',
      nodeTypeEntity: 'Entity',
      nodeTypeConcept: 'Concept',
      nodeTypeSource: 'Source literature',
      nodeTypePhantom: 'Phantom node',
      subscribe: 'Subscribe',
      nodeDetail: 'Knowledge point details',
      close: 'Close',
      preview: 'Preview',
      dragSort: 'Drag to reorder',
      outlineNav: 'Outline navigation',
      noTopicSelected: 'No topic selected',
      outlineMeta: '{categories} top-level sections · {nodes} knowledge points',
      emptyOutline: 'No outline content for this topic',
      nodesInCategory: '{count} knowledge points',
      outlinePointTitle: '{category} point {index}',
      viewWiki: 'Wiki',
      wikiAccessDeniedTier: 'Your tier does not include LLM Wiki or graph; mind map and outline still work',
      wikiAccessDeniedMenu: 'No LLM Wiki menu permission; you can still add materials to mind map and outline',
      wikiAccessLocked: 'Wiki add-on locked',
      wikiOptInLabel: 'LLM Wiki',
      wikiOptInDesc: 'When on, shows Wiki and knowledge graph (wikilink topology); auto-maintains topics; billed by usage (X-Coin)',
      wikiOptInTitle: 'Enable LLM Wiki',
      wikiOptInConfirm: 'LLM Wiki and the knowledge graph are usage-based. Enabling triggers background Wiki maintenance when you add materials and shows Wiki, graph, and related actions. Continue?',
      wikiOptInConfirmBtn: 'Enable',
      wikiOptInEnabled: 'LLM Wiki enabled',
      wikiOptInDisabled: 'LLM Wiki disabled',
      wikiOptInOffHint: 'LLM Wiki is off by default — turn it on from the toolbar first',
      msgNodeAdded: 'Added to knowledge map',
      msgAddToMapSuccess: 'Successfully added to knowledge map',
      msgAddToMapSuccessWikiPending: 'Added to knowledge map — Wiki overview will update in the background',
      addToMapDialogTitle: 'Add to knowledge map',
      addToMapSubmit: 'Add to knowledge map',
      addToMapAndWikiSubmit: 'Add and organize Wiki',
      addToMapContentPreview: 'Content preview',
      addToMapContentPlaceholder: 'Edit or trim content. Markdown is supported.',
      addToMapKnowledgeTitle: 'Knowledge point title',
      addToMapTitlePlaceholder: 'Optional. Click "Auto classify" for a smart suggestion.',
      addToMapClassifySettings: 'Classification settings',
      addToMapClassifySubtitle: 'Choose manually, or type and click "Create"',
      addToMapAnalyzing: 'Analyzing...',
      addToMapAutoClassify: 'Auto classify',
      addToMapRelatedTopic: 'Related topic',
      addToMapRelatedCategory: 'Related category',
      addToMapTopDirectory: 'Top-level directory',
      addToMapSelectOrCreate: 'Select or create',
      addToMapInfoBase: 'Saves as map material — view and edit in mind map and outline',
      addToMapInfoSeparator: '. ',
      addToMapInfoWiki: 'After saving, the topic LLM Wiki overview will update in the background',
      addToMapInfoMapOnly: 'LLM Wiki and graph are add-ons (mind map and outline are unaffected)',
      addToMapInfoOptInOff: 'Material only this time; enable LLM Wiki in the toolbar to trigger maintenance',
      optional: 'Optional',
      createOption: 'Create "{name}"',
      directoryTarget: 'Target',
      directoryDisease: 'Disease',
      directoryTechnologyMethod: 'Technology method',
      directoryDrug: 'Drug',
      directoryMechanismPathway: 'Mechanism pathway',
      directoryPaperReading: 'Paper deep read',
      directoryExperimentMethod: 'Experimental method',
      directoryOther: 'Other',
      categoryGeneralContent: 'General content',
      operationFailedRetry: 'Operation failed. Please try again later.',
      msgFillContentBeforeAutoClassify: 'Enter content before auto classification',
      msgAutoClassifyComplete: 'Auto classification complete. Suggested fields filled.',
      msgSmartExtractUnavailableUseSummary: 'Smart analysis is unavailable. The content summary was used as the topic.',
      msgLoadTopicsFailed: 'Failed to load knowledge map topics',
      msgLoadTopicCategoriesFailed: 'Failed to load topic categories',
      msgContentRequired: 'Content cannot be empty',
      msgSelectOrEnterTopic: 'Select or enter a related topic',
      msgAddToMapFailed: 'Failed to add to knowledge map',
      wikiUpgradeHint: 'Click to open recharge center',
      cancel: 'Cancel',
      save: 'Save',
      confirm: 'OK',
      create: 'Create',
      addMaterial: 'Add material',
      organizeWiki: 'Organize Wiki',
      exportMarkdown: 'Markdown',
      outlineHitCount: '{count} matches',
      moveNodesCount: 'Move points ({count})',
      moveCategoriesCount: 'Move categories ({count})',
      subscribed: 'Subscribed',
      moveTo: 'Move to...',
      unsubscribe: 'Unsubscribe',
      deleteCategory: 'Delete category',
      editContent: 'Edit content',
      refresh: 'Refresh',
      graphStatSummary: '{visible}/{total} nodes · {edges} edges',
      graphUndefinedSummary: '{count} undefined nodes',
      graphIsolatedSummary: '{count} isolated nodes',
      graphAvgEdgeWeightSummary: 'Avg co-occurrence {value}',
      graphAvgRelationPuritySummary: 'Avg relation purity {value}',
      graphLowPuritySummary: '{count} low-purity edges',
      graphMinEdgeWeight: 'Min edge weight',
      graphMinRelationPurity: 'Min relation purity',
      graphWeightPresetP50: 'P50',
      graphWeightPresetP75: 'P75',
      graphWeightPresetP90: 'P90',
      graphRelationSummaryTag: '{relation} weight {weight}',
      graphRelationSummaryTooltip: '{count} edges · co-occurrence {weight}',
      graphRelationChipStat: '{relation} · {count} edges/{weight} weight',
      graphTooltipRelationPurity: 'Relation purity: {value}%',
      graphQualityScoreSummary: 'Quality {value}',
      graphEvidenceCoverageSummary: 'Evidence {value}%',
      graphEdgeStrength: 'Weight {count}',
      graphEdgeEvidenceCount: 'Evidence snippets',
      graphEdgeDirectionPurity: 'Direction consistency',
      graphEdgeDirectionMix: 'Direction mix',
      graphEdgeEvidence: 'Relation evidence',
      graphNoEdgeEvidence: 'No evidence snippets available.',
      graphEdgeDetailHint: 'Click a node to switch · Esc close',
      healBrokenLinks: 'Heal broken links',
      resetFilters: 'Reset filters',
      showUndefinedOnly: 'Undefined only',
      showAllNodeTypes: 'Show all types',
      community: 'Community #{n}',
      directNeighbors: 'Direct links',
      materialStatus: 'Material status',
      networkConnectivity: 'Connectivity',
      relatedEntities: 'Related entities · {count}',
      relationDistribution: 'Relation distribution',
      noDirectNeighbors: 'No direct links. Refresh topology or add [[wikilinks]].',
      locateInOutline: 'Locate in outline',
      locateInWiki: 'Locate in Wiki',
      tryHealBrokenLinks: 'Try heal broken links',
      graphDetailHint: 'Esc close · Double-click to focus',
      graphLegendTip: 'Click legend to filter · Drag nodes · Scroll to zoom',
      locateOutline: 'Locate in outline',
      previous: 'Previous',
      next: 'Next',
      layout: 'Layout',
      layoutHorizontal: 'Horizontal',
      layoutVertical: 'Vertical',
      layoutRadial: 'Radial',
      depth: 'Depth',
      depthMarkAll: 'All',
      mindmapEmptyTitle: 'No material nodes to display for this topic',
      mindmapEmptyTip: 'Add knowledge points in outline view, or switch topic',
      legendTopic: 'Topic',
      legendCategory: 'Category',
      legendNode: 'Knowledge point',
      mindmapLegendTip: 'Tip: scroll to zoom, drag to pan, click a point to open material',
      graphEmptyFiltered: 'No nodes match current filters',
      askWikiEmptyTitle: 'Ask a question to start semantic discussion on this knowledge graph',
      askWikiEmptyTip: 'Click "Archive synthesis" under AI replies to create a permanent node',
      referenceSources: 'References',
      relevance: 'Relevance {score}',
      archiveSynthesis: 'Archive as synthesis',
      send: 'Send',
      ctrlEnterHint: 'Ctrl + Enter to send',
      lintConfigTitle: 'Diagnosis settings',
      lintStart: 'Run health check',
      deepLintTitle: 'Deep semantic audit',
      deepLintDesc: 'Uses an advanced model to detect cross-literature contradictions, staleness, and gaps.',
      deepLintCostWarning: 'Deep audit uses LLM credits (~3–5 X-Coin per run).',
      lintNoReport: 'No diagnosis report yet',
      lintNoReportTip: 'Click "Run health check" above to scan graph structure',
      lintRunning: 'Running deep graph health check...',
      lintRunningTip: 'Scanning broken links, orphan literature, missing concepts, and conflicts',
      lintStructuralReport: '📊 Structural health report',
      lintNodesScanned: 'Nodes scanned',
      lintBrokenLinks: 'Broken links',
      lintOrphans: 'Orphan materials ({count})',
      lintOrphansTip: 'These materials have no [[wikilink]] references. Link them during Wiki organization.',
      lintNoOrphans: '🎉 No orphan literature — good linkage!',
      lintMissingEntities: 'Frequent mentions without entities ({count})',
      lintMissingEntitiesTip: 'Often cited but no entity card yet. Use Smart heal to synthesize in batch.',
      lintMentionCount: 'Mentioned {count} times',
      lintOneClickSynthesis: 'Synthesize',
      lintAllEntitiesCreated: '🎉 All key concepts have entity cards!',
      lintSemanticReport: '🧠 Deep semantic conflict report',
      sourceLlmWiki: 'LLM Wiki',
      sourceConcept: 'Concept',
      sourceSynthesis: 'Synthesis',
      sourceManual: 'Manual',
      sourceUnknown: 'Unknown',
      nodeTypeSynthesisShort: 'Synth',
      nodeTypeEntityShort: 'Entity',
      nodeTypeConceptShort: 'Concept',
      nodeTypeSourceShort: 'Source',
      nodeTypePhantomShort: 'Phantom',
      wikiEmptyRunning: 'Wiki is generating in the background',
      wikiEmptyNoContent: 'Wiki overview exists but body is empty',
      wikiEmptyNotGenerated: 'No Wiki overview for this topic yet',
      wikiEmptyTipRunning: 'This page will refresh when done, or check back later.',
      wikiEmptyTipNoContent: 'Click Regenerate, or add materials first then regenerate.',
      wikiEmptyTipDefault: 'After adding materials, Wiki is maintained automatically in the background.',
      entityTypeConcept: 'concept entry',
      entityTypeEntity: 'entity entry',
      entityIndexPlaceholder: 'This encyclopedia {type} is indexed; body is still being generated. Use graph heal or edit to complete.',
      synthesisEmptyPlaceholder: 'This synthesis node has no body yet. Edit manually to add content.',
      unnamedNode: 'Unnamed node',
      unnamedKnowledgePoint: 'Unnamed knowledge point',
      unnamed: 'Unnamed',
      unknown: 'Unknown',
      unclassified: 'Uncategorized',
      unclassifiedNodes: 'Uncategorized knowledge points',
      exportWikiOverview: 'LLM Wiki overview',
      exportCategoryMaterials: 'Materials by category',
      exportMaterialItem: 'Material {index}',
      exportSourceLabel: 'Source: ',
      exportTimeLabel: 'Time: ',
      graphTooltipType: 'Type: ',
      graphTooltipCategory: 'Category: ',
      graphTooltipNeighbors: 'Links: {count} nodes',
      graphTooltipHint: 'Click for details · Double-click to focus',
      graphTooltipEdge: 'Edge: {source} → {target} ({relation})',
      graphTooltipWeight: 'Co-occurrence strength: {count}',
      graphTooltipRelationMix: 'Relation mix: {mix}',
      graphRelationWikilink: 'Wiki link',
      graphRelationMentions: 'Overview mention',
      graphRelationSourceOverlap: 'Source overlap',
      graphRelationRelated: 'Related',
      graphColorModeType: 'Color by type',
      graphColorModeCommunity: 'Color by community',
      graphInsightsTitle: 'Graph insights',
      graphInsightSurprising: 'Surprising links',
      graphInsightGaps: 'Knowledge gaps',
      graphInsightCohesion: 'Cohesion {value}',
      graphInsightHighlight: 'Highlight',
      graphTooltipRelevance: 'Relevance: {score}',
      graphTooltipLinkCount: 'Wiki-link count: {count}',
      graphInsightHeal: 'Smart heal',
      graphClearHighlight: 'Clear highlight',
      graphInsightLintMerged: 'Health check merged',
      graphInsightLintLoading: 'Syncing health check…',
      graphInsightLintFailed: 'Failed to load insight health data; the graph remains usable',
      graphInsightBrokenLinks: '{count} broken links',
      graphInsightBrokenLinksTip: 'Wiki links point to missing nodes. Try smart heal.',
      graphInsightMissingEntities: '{count} missing entities',
      graphInsightMissingEntitiesTip: 'Frequently mentioned concepts lack entity cards.',
      graphInsightLintOrphans: '{count} orphan sources',
      graphInsightSparseNodes: '{count} sparse links',
      graphInsightSparseNodesTip: 'Few outbound links. Add wikilinks or related sources.',
      graphInsightAllGood: 'Graph structure looks healthy. No major gaps detected.',
      recallPathDirect: 'Direct recall',
      recallPathGraph1: 'Graph 1-hop',
      recallPathGraph2: 'Graph 2-hop',
      msgAskWikiSourceLocated: 'Located source: {title}',
      graphNeighborRelevance: 'Relevance {score}',
      graphRelevanceSignals: 'Relevance signals',
      graphEdgeStrong: 'Strong link',
      graphEdgeWeak: 'Weak link',
      msgOperationFailed: 'Operation failed. Try again later.',
      msgLoadTopicDetailFailed: 'Failed to load topic details',
      msgWikiMarkdownExported: 'Wiki Markdown exported',
      msgExportWikiFailed: 'Wiki export failed',
      msgTopicMarkdownExported: 'Topic Markdown exported',
      msgExportTopicFailed: 'Topic export failed',
      msgCopiedToClipboard: 'Copied to clipboard',
      msgCopyFailed: 'Copy failed',
      msgWikiRegenerated: 'Wiki regeneration complete',
      msgWikiRegenerateFailed: 'Wiki run failed; current content kept{reason}',
      msgWikiStillRunning: 'Wiki still running in background. Refresh later.',
      msgNoMaterialsForWiki: 'No materials — cannot organize Wiki',
      msgWikiRegenerateSubmitted: 'Regeneration submitted; tracking progress',
      msgWikiRegenerateSubmitFailed: 'Failed to submit regeneration',
      msgCategoryUnsubscribed: 'Category subscription disabled',
      msgUnsubscribeFailed: 'Failed to unsubscribe',
      msgFitScreenDone: 'Fit to screen',
      msgNoMatchingNode: 'No matching node',
      msgMindmapLocated: 'Located {index}/{total}: {path}',
      msgOutlineCardNotFound: 'Switched to outline but card not found',
      msgExportSuccess: 'Export succeeded',
      msgExportFailed: 'Export failed',
      msgFullscreenFailed: 'Fullscreen toggle failed',
      msgCreateSuccess: 'Created',
      msgCreateFailed: 'Create failed',
      msgTopicNameRequired: 'Topic name is required',
      msgMergePrompt: 'Selected topics will be deleted and merged. Enter name for the kept topic:',
      msgMergeConfirm: 'Merge',
      msgNameRequired: 'Name is required',
      msgMergeSuccess: 'Merge succeeded',
      msgBatchDeleteConfirm: 'Delete selected topics and all knowledge points? This cannot be undone.',
      msgBatchDeleteTitle: 'Batch delete',
      msgBatchDeleteSuccess: 'Batch delete succeeded',
      msgBatchHealConfirm: 'Trigger smart-heal background tasks for {count} selected topics?',
      msgBatchHealAllConfirm: 'Trigger smart-heal background tasks for all topics in this account?',
      msgBatchHealTitle: 'Batch smart heal',
      msgBatchHealSubmitted: 'Batch heal submitted: queued {queued}, skipped {skipped}, failed {failed}',
      msgBatchHealFailed: 'Failed to submit batch smart heal',
      msgDeleteTopicConfirm: 'Also delete all knowledge points under this topic? Cannot be undone.',
      msgDeleteTopicTitle: 'Delete topic',
      msgDeleteAll: 'Delete all',
      msgDeleteSuccess: 'Deleted',
      msgNodeContentRequired: 'Knowledge point content cannot be empty',
      msgSaved: 'Saved',
      msgSaveFailed: 'Save failed',
      msgSectionUpdated: 'Section updated',
      msgSaveSectionFailed: 'Failed to save section',
      msgPinned: 'Pinned',
      msgUnpinned: 'Unpinned',
      msgMovedToCategory: 'Moved to new category',
      msgMoveNodeFailed: 'Failed to move knowledge point',
      msgSelectNodeForFocus: 'Select a node to focus its neighborhood',
      msgKeepOneNodeType: 'Keep at least one node type',
      msgKeepOneRelationType: 'Keep at least one relation type',
      msgDeleteNodeConfirm: 'Delete this knowledge point? Cannot be undone.',
      msgDeleteNodeTitle: 'Delete knowledge point',
      msgDeleteFailed: 'Delete failed',
      msgRenamed: 'Renamed',
      msgDeleteCategoryWithNodesChoose: 'This category has {count} knowledge points. Choose how to delete:',
      msgDeleteCategoryConfirm: 'Delete this category?',
      msgDeleteCategoryTitle: 'Delete category',
      msgDeleteCategoryAndNodes: 'Delete category and points',
      msgDeleteCategoryOnly: 'Delete category only (move to uncategorized)',
      msgCategoryAndNodesDeleted: 'Category and points deleted',
      msgCategoryDeletedNodesMoved: 'Category deleted; points moved to uncategorized',
      msgCategoryNameRequired: 'Enter category name',
      msgSelectTopicFirst: 'Select a topic first',
      msgEnterNodeContent: 'Enter knowledge point content',
      msgNodeAddedWikiPending: 'Added; Wiki will organize in background',
      msgAddFailed: 'Add failed',
      msgMoveSuccess: 'Move succeeded',
      msgMoveSuccessInTopic: 'Moved. View in "{name}"',
      msgMoveFailed: 'Move failed',
      msgSelectNodesAndTopic: 'Select knowledge point(s) and a target topic',
      msgSelectCategoryAndTopic: 'Select categories to move and target topic',
      msgCategoryMoveSuccess: 'Category moved. View in "{name}"',
      msgMoveCategoryFailed: 'Failed to move category',
      msgNodeNameCopied: 'Node name copied',
      msgCopyManual: 'Copy failed — copy manually',
      msgNoGraphMatch: 'No matching nodes',
      msgNoMaterialCard: 'No material card for this node',
      msgGraphNodeNotInOutline: 'Graph node not loaded in outline',
      msgLocated: 'Located: {name}',
      msgFetchTopologyFailed: 'Failed to fetch topology',
      msgHealTaskStarted: 'Heal task started; refreshing topic',
      msgHealTriggerFailed: 'Failed to trigger heal',
      msgArchiveWikiConfirm: 'Archive will set Wiki lifecycle to archived. Continue?',
      msgWikiArchived: 'Wiki archived',
      msgArchiveFailed: 'Archive failed',
      msgWikiRestored: 'Wiki restored to active',
      msgRestoreFailed: 'Restore failed',
      msgNoAnswer: 'No answer',
      msgAskWikiFailed: 'Discussion failed: {detail}',
      msgSynthesisTitlePrompt: 'Enter title for archived synthesis:',
      msgSynthesisArchiveTitle: 'Archive synthesis',
      msgConfirmArchive: 'Archive',
      msgSynthesisDefaultTitle: 'Discussion: {preview}...',
      msgTitleRequired: 'Title is required',
      msgSynthesisArchived: 'Discussion archived as synthesis node!',
      msgArchiveSynthesisFailed: 'Archive synthesis failed',
      msgLintSuccess: 'Graph health check complete!',
      msgLintFailed: 'Graph health check failed',
      msgOrphanNotFound: 'Material card not found: {title}',
      msgOrphanLocated: 'Located material: {title}',
      msgEntityLocated: 'Located entity: [[{name}]]',
      msgGraphEntityLocated: 'Switched to graph and located: [[{name}]]',
      msgWikiEntityLocated: 'Located in Wiki: [[{name}]]',
      msgWikiLinkNotFound: 'No [[{name}]] wikilink in Wiki body',
      msgEntityNotIndexed: '[[{name}]] not indexed. Check graph for phantom links or run heal.',
      msgEntityMultipleMatches: '[[{name}]] matches multiple nodes. Use a more specific wikilink.'
    },
    subscription: {
      back: 'Back to knowledge map',
      title: 'Map subscription settings',
      subtitle: 'Keywords per top-level category; periodic literature, patent, clinical, and news updates to notifications.',
      typeTag: 'Knowledge map',
      viewFeed: 'View updates',
      typeHint: 'Subscription types',
      hintMap: 'Knowledge map subscription: external intel by topic/category keywords; add to mind map / Wiki.',
      hintReport: 'Report update subscription: configured on target report tasks, includes pipeline logs. Go to task details → Intelligence subscription.',
      planSection: 'Collection plan',
      scopeCategory: 'Single category',
      scopeTopic: 'Whole topic',
      enable: 'Enable subscription',
      patrolOn: 'Patrol enabled',
      patrolOff: 'Patrol disabled',
      interval: 'Patrol interval',
      preset: 'Quick',
      preset1d: '1 day',
      preset7d: '7 days',
      preset30d: '30 days',
      scopeNote: 'Category-level subscription; use mind map top bar for topic-level',
      dimensions: 'Collection dimensions',
      dimAll: 'All',
      dimLiterature: 'Literature',
      dimPatent: 'Patents',
      dimClinical: 'Clinical trials',
      dimNews: 'Web news',
      pipelineNote: 'Map subscriptions exclude report pipeline dimension (report intelligence subscription only)',
      keywords: 'Search keywords (top-level category)',
      customKeywords: 'Custom keywords — save after editing',
      previewSearch: 'Preview search',
      restoreAuto: 'Restore auto-generated',
      trySearch: 'Try search',
      keywordPlaceholder: 'Enter search keywords for this category',
      autoKeywordHint: 'Keywords will be auto-generated from top-level categories after save',
      notifyChannels: 'Notification channels',
      notifyCenter: 'Notification center',
      email: 'Email',
      emailPlaceholder: 'Leave empty to use account email',
      feishuWebhook: 'Feishu webhook',
      keepExisting: 'Keep existing',
      updateUrl: 'Update URL',
      clear: 'Clear',
      feishuApp: 'Feishu app message',
      feishuInternalOnly: 'xtalpi.com users only',
      unsaved: 'Unsaved changes',
      synced: 'Settings synced',
      save: 'Save settings',
      collectNow: 'Collect now',
      testNotify: 'Test notification',
      lastCollect: 'Last collection',
      refresh: 'Refresh',
      nextPlan: 'Next scheduled',
      subscriptionScope: 'Subscription scope',
      previewRunning: 'Preview search running: {query}',
      keywordSearchFallback: 'Keyword search',
      viewProgress: 'View progress',
      previewDialogTitle: 'Preview search',
      keywordColon: 'Keywords:',
      previewSanitized: 'Query auto-simplified: {query}',
      previewBgHint: 'Preview runs in background (30s–3min). You may close this dialog and keep configuring.',
      previewNoResults: 'No results. Try shorter keywords or adjust collection dimensions.',
      runInBackground: 'Run in background',
      intervalAbout1Day: '~1 day',
      intervalAboutDays: '~{days} days',
      intervalAbout1Hour: '~1 hour',
      intervalAboutHours: '~{hours} hours',
      intervalAboutMinutes: '~{minutes} min',
      customKeyword: 'Custom',
      categoryFallback: 'Category',
      previewFailed: 'Preview search failed',
      previewDoneWithTotal: 'Preview done: {total} results',
      previewDoneNoHits: 'Preview done: no matches',
      previewStillRunning: 'Preview still running. Click View progress later.',
      keywordMinLength: 'Keywords need at least 2 characters',
      previewTaskFailed: 'Failed to submit preview task',
      previewSubmitFailed: 'Preview submit failed',
      loadKeywordsFirst: 'Save or load keywords first',
      keywordsAutoRestored: 'Restored auto-generated keywords',
      restoreFailed: 'Restore failed',
      invalidTopic: 'Invalid topic. Open from knowledge map again.',
      loadConfigFailed: 'Failed to load subscription settings',
      enabledFirstCollect: 'Subscription enabled; first collection started in background',
      confirmGoFeedTitle: 'First collection',
      confirmGoFeedMessage: 'Go to subscription updates to watch collection progress?',
      stayOnPage: 'Stay here',
      configSaved: 'Subscription settings saved',
      saveFailed: 'Save failed',
      statusQueued: 'Queued',
      statusRunning: 'Running',
      statusSucceeded: 'Succeeded',
      statusPartialFailed: 'Partial failure',
      statusFailed: 'Failed',
      statusSkipped: 'Skipped',
      saveBeforeCollect: 'Save settings before collecting',
      collectQueueFailed: 'Failed to queue collection',
      collectInProgress: 'Collection in progress…',
      collectFailed: 'Collection failed ({status})',
      collectDone: 'Collection done ({status}). View updates?',
      collectDoneTitle: 'Collection complete',
      confirmGoFeedAfterCollect: 'Go to subscription updates now?',
      collectBgRunning: 'Collection still running. Check View updates later.',
      collectSubmitted: 'Collection task submitted',
      triggerCollectFailed: 'Failed to trigger collection',
      testNotifySent: 'Test notification sent',
      testNotifyPartial: 'Some channels failed. Check settings.',
      testNotifyFailed: 'Test notification failed',
      hintMapLabel: 'Knowledge map subscription',
      hintReportLabel: 'Report update subscription',
      feishuWebhookPlaceholder: 'https://open.feishu.cn/open-apis/bot/v2/hook/...',
      feedTitle: 'Map subscription updates',
      emptyNoRuns: 'No collection runs yet',
      emptyNoRunsDesc: 'Enable subscription for automatic first run, or use Collect now on settings.',
      goToConfig: 'Subscription settings',
      feedStreamTitle: 'Collection feed',
      feedStreamDesc: 'Hits from patrol runs by time; batch-add to the knowledge map. LLM Wiki organize when your tier and menu allow.',
      batchCount: '{total} batches',
      notified: 'Notified',
      hitCount: '{count} hits',
      refRelevance: 'Relevance {score}',
      sourceDistribution: 'Source mix',
      selectAllBatch: 'Select batch',
      llmExtractAdd: 'LLM classify then add',
      llmExtractTip: 'LLM suggests title and category before ingest; bills X-Coin. Does not trigger Wiki. Use “Extract and organize Wiki” for Wiki (requires LLM Wiki permission).',
      addToKnowledgeMap: 'Add to knowledge map',
      extractAndWiki: 'Extract & organize Wiki',
      seenBefore: 'Seen before',
      addedToMap: 'Added to map',
      loadMore: 'Load more',
      loadFailed: 'Load failed',
      loadMoreFailed: 'Load more failed',
      selectItemsFirst: 'Select items to add first',
      addedCount: 'Added {count} to knowledge map',
      wikiTriggered: '; Wiki organization triggered',
      addFailed: 'Add failed',
      wikiFeatureLockedHint: '“Extract and organize Wiki” needs Plus+ and LLM Wiki permission. “Add to knowledge map” still saves to mind map and outline.',
      wikiOptInFeedHint: 'LLM Wiki is off by default. You can still use “Add to knowledge map”; enable the toolbar switch for Wiki maintenance.'
    }
  }
}
